const Skeleton = ({ className, ...props }) => {
  return (
    <div
      className={`animate-pulse bg-primary-100/50 dark:bg-primary-900/20 rounded ${className}`}
      {...props}
    />
  );
};

export default Skeleton;
